module.exports = __webpack_public_path__ + "img/mobile_map_milan.61a27d78.svg";